export const infoData = [
  { id: "ready", name: "READY" },
  { id: "unknown", name: "UNKNOWN" },
  { id: "inprogress", name: "IN PROGRESS" },
  { id: "aborted", name: "ABORTED" },
  { id: "passed2", name: "PASSED" },
  { id: "internalerror", name: "INTERNAL ERROR" },
  { id: "wiremapfailed", name: "WIREMAP FAILED" },
  { id: "speedtestinprogress", name: "SPEED TEST IN PROGRESS" },
  { id: "speedtestfailednext", name: "SPEED TEST FAILED (NEXT)" },
  { id: "speedtestfailedil", name: "SPEED TEST FAILED (IL)" },
  { id: "speedtestfailedrl", name: "SPEED TEST FAILED (RL)" }
];
